<template>
  <div>
    <div class="information">
      <van-list
        v-model="loading"
        :finished="finished"
        offset="30"
        @load="onLoad"
        finished-text="没有更多了"
        :immediate-check="false"
      >
        <!-- 全部 -->
        <div class="center borderClass" v-for="item in list" :key="item.index">
          <!--  JSON.stringify(item) -->
          <div @click="gotoUrl('/governmentAffairs/detail/' +item.aid)">
            <div class="Content">
              <div
                style="display: inline-block; width: 33%"
                class="ContentA"
                ref="getHeight"
              >
                <img
                  v-if="item.aimg"
                  style="border-radius: 5px; height: 90px; object-fit: cover"
                  :src="item.aimg"
                  alt=""
                />
                <img
                  v-else
                  style="border-radius: 5px; height: 90px; object-fit: cover"
                  src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cdb4.png"
                  alt=""
                />
              </div>
              <div style="display: inline-block; width: 63%" class="ContentB">
                <div class="centerTitle van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
                <span
                  class="centertime van-multi-ellipsis--l2"
                  style="margin: 5px 0px; font-size: 13px; color: #666666"
                  >{{ item.newti }}</span
                >
              </div>
              <span
                class="centertime"
                style="float: right; margin-top: -10px; color: black"
                >{{ item.CreateTime | timeFilter }}</span
              >
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- v-if="isAuth == 1" -->
    <!-- 发布活动 -->
    <!-- <div
      class="backTop"
      @click="gotoUrl('/article/addActivity')"

    >
      <img
        class="top_iamge"
        src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/eae3.png"
        alt=""
      />
    </div> -->
  </div>
</template>
<script>
import { setOpenId, getOpenId, getIsWorkMan } from "@/utils/auth";
import { taskPage } from "@/api/RealInfo";
export default {
  data() {
    return {
      isWorkMan: "",
      tkId: 0, //tab栏
      activeName: "",
      list: [], //资讯列表
      listfrom: {
        page: 1,
        limit: 10,
      }, //查询传参
      hidden: true, //没有更多数据了
      TitleList: [],
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
    };
  },
  filters: {
    timeFilter(value) {
      if (value != undefined) {
        let gstime = value.replace("T", " ");
        return gstime;
      }
    },
  },
  methods: {
    // 发布活动
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },
    delHtmlTag(str) {
      if (!str) {
        return
      }
      str = str.replace(/<([a-z]+?)[^>]*>/g, '')
      return str.replace(/<\/([a-z]+?)+>/g, '') // 去掉所有的html标记
    },
    escape2Html(str) {
      if (!str) {
        return
      }
      return str.replace(/&+[a-zA-Z]+;/g, '')
      // var arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' }
      // return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
      //   return arrEntities[t]
      // })
    },
    // 获取分页列表
    getList() {
      taskPage(this.listfrom)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            let rows = res.data.data; //请求返回当页的列表
            console.log(rows);
            // 加载状态结束
            this.loading = false;

            if (res.data.code == 0) {
              if (rows == null || rows.length === 0) {
                // 加载结束
                console.log("结束");
                this.finished = true;
                this.hidden = true;
                return;
              }
              res.data.data.forEach(e => {
                const newti = this.delHtmlTag(e.content)
                e.newti = this.escape2Html(newti)
              });
              // 将新数据与老数据进行合并
              this.list = this.list.concat(rows);

              //如果列表数据条数>=总条数，不再触发滚动加载
              if (this.list.length >= res.data.count) {
                this.finished = true;
                this.hidden = true;
              }
            }
          }
        })
        .catch(() => {});
    },

    // 下拉加载更多
    onLoad() {
      console.log(123);
      this.listfrom.page = this.listfrom.page + 1;
      this.getList();
    },
  },
  mounted() {
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }
    this.isWorkMan = getIsWorkMan();
    console.log(this.$route.query["isAuth"])
    this.getList();
  },
};
</script>
<style scoped>
.hidden {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin: 10px 0px 25px 0px;
}
.information {
  width: 95%;
  margin: auto;
}
.borderClass {
  padding: 0;
  box-shadow: 0px 5px 17px 1px rgb(0 0 0 / 7%);
}
.borderClass .Content {
  padding: 8px;
  margin-top: 10px;
}

.backTop {
  display: flex;
  position: fixed;
  bottom: 125px;
  right: 10px;
  width: 75px;
  height: 75px;
}

.top_image {
  width: 75px;
  height: 75px;
}
</style>
